import React from 'react';
import AlertBar from '~components/common/AlertBar';
import { CustomizableLink } from '~components/common/Link';
import { useStateField, useStateName } from '~state/getStateField';

function SameDayRegistrationAlert() {
  const displayAlert = process.env.GATSBY_SDR_ALERTS_ENABLED === 'true';
  const stateName = useStateName();
  const hasSdrEarlyVoting = useStateField('has_sdr_early_voting');
  const hasSdrElectionDay = useStateField('has_sdr_election_day');
  const hasSdr = hasSdrEarlyVoting || hasSdrElectionDay;

  if (!displayAlert || !stateName || !hasSdr) {
    return null;
  }

  return (
    <AlertBar alertType='info'>
      <div>
        Close to Election Day? Consider same day registration: {stateName}{' '}
        allows you to register in person and vote on the same day.{' '}
        <CustomizableLink
          href='/same-day-registration/'
          title={`Learn more about ${stateName} same day registration`}
        >
          Learn more here
        </CustomizableLink>
        .
      </div>
    </AlertBar>
  );
}

export default SameDayRegistrationAlert;
